import * as React from 'react';
import type { SVGProps } from 'react';

const SvgIn = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 1200" {...props}>
    <path d="m931.02 803.32 12.176-13.391-1.809-192.93-2.832-271.09-3.378-252.12-.504-21.785-196.46 3.535-224.7-1.34-56.578 30.242-71.082.786-18.95-19.07-4.558 322.77-4.64 322.39-25.669 77.14 17.543 20.649 10.82 47.707-2.156 37.43-18.574 16.652-16.52 45.895-46.43 59.977-32.148 74.223-8.113 56.176 28.434 7.738 2.793-30.695 56.492 22.473 47.766-29.828 67.488 43.156 16.965-26.953 50.953-26.152 47.219 32.96 24.555-30.956 38.406-55.402 13.762 34.07 44.738 23.809 48.03-83.02 31.083-8.895 28.484-48.07 30.613-20.676 4.125-53.516 51.707 9.489 33.793-25.027 36.66-1.016 9.015-20.766z" />
  </svg>
);
export default SvgIn;
